import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  button: {
    height: 56,
    width: 56,
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 100,
  },

  icon: {
    width: 16,
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
});

export default styles;
